/**
 * Per-signal judgment for billing integrity metrics.
 * `insufficient_data` is distinct from within_threshold: absence of sample
 * size must never read as compliance.
 */
export enum BillingIntegrityVerdictEnum {
  BREACHED = 'breached',
  WITHIN_THRESHOLD = 'within_threshold',
  INSUFFICIENT_DATA = 'insufficient_data',
}
